import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useMarkAllNotificationsReadMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: () => r.markAllRead(),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.unreadCount() });
		}
	});
};
//#endregion
export { i as useMarkAllNotificationsReadMutation };
